import { zEntity } from "src/types/ZEntity";
import { z } from "zod";

export const zAttrFinancialValue = z.object({
  moneyValue: z.string().array().nullable().optional(),
  currencyEntity: zEntity.optional().nullable(),
});
export type ZAttrFinancialValue = z.infer<typeof zAttrFinancialValue>;
